import { IOdataResult } from '../odata.model';
import { ISyncStatus } from './dataSync.model';

export interface ITechnician {
  code: string;
  displayName: string;
  branchCode: string;
  branchOffset: number;
  scheduleCode: string;
  efficiency: number;
  isTerminated: boolean;
}

export interface IWorkCategory {
  technicianCode: string;
  workCategory: string;
  profileName: string;
  isDefault: boolean;
}

export interface IWorkCategorySyncStatus extends ISyncStatus {
  data: IOdataResult<IWorkCategory>;
}

export const UNKNOWN_TECH = 'UNKNOWN_TECH';